// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-container {
    background-color: #ffffff;
    border-radius: 8px 8px 0 0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    border: 1px solid var(--therapist-border-color);
    padding: 1.5rem;
    height: calc(100vh - 320px);
    overflow-y: auto;
}

.form-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative; /* Added for overlay positioning */
}

.navigation-buttons {
    background: #fff;
    padding: 1rem 1.5rem;
    border: 1px solid var(--therapist-border-color);
    border-top: none;
    border-radius: 0 0 8px 8px;
    display: flex;
    gap: 1rem;
    justify-content: flex-end;
}

.form-title {
    border-bottom: 2px solid var(--therapist-border-color);
    margin-bottom: 1.5rem;
    padding-bottom: 1rem;
}

.form-title p {
    font-size: 20px;
    font-weight: 500;
    color: var(--therapist-text-color);
    margin: 0;
}

.navigation-buttons button {
    padding: 0.5rem 1.5rem;
    border: 1px solid var(--therapist-accent-color);
    background-color: #fff;
    color: var(--therapist-accent-color);
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
}

.navigation-buttons button:hover:not(:disabled) {
    background-color: var(--therapist-accent-color);
    color: #fff;
}

/* New styles for loading states */
.navigation-buttons button:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    border-color: var(--therapist-border-color);
    color: var(--therapist-text-color);
}

.button-loading {
    background-color: var(--therapist-border-color) !important;
    border-color: var(--therapist-border-color) !important;
    color: var(--therapist-text-color) !important;
}

.save-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    border-radius: 8px;
}

.save-overlay-content {
    background-color: white;
    padding: 1.5rem 2rem;
    border-radius: 6px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    text-align: center;
    border: 1px solid var(--therapist-border-color);
}

.save-overlay-content p {
    color: var(--therapist-text-color);
    margin: 0.5rem 0 0;
    font-size: 14px;
    font-weight: 500;
}

.spinner {
    border: 3px solid var(--therapist-border-color);
    border-top: 3px solid var(--therapist-accent-color);
    border-radius: 50%;
    width: 24px;
    height: 24px;
    animation: spin 1s linear infinite;
    margin: 0 auto;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.summary-section {
    border: 1px solid var(--therapist-border-color);
    border-radius: 10px;
    background-color: #f0f8ff;
    margin: 40px 0;
    padding: 20px;
}

.summary-section p {
    color: var(--therapist-text-color);
}

.summary-section span {
    font-weight: 500;
}

.summary-section p:last-child {
    margin: 0;
}

.summary-section-title {
    color: var(--therapist-text-color);
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./app/components/therapist/medical-history/styles/Form.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,yCAAyC;IACzC,+CAA+C;IAC/C,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,kBAAkB,EAAE,kCAAkC;AAC1D;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,+CAA+C;IAC/C,gBAAgB;IAChB,0BAA0B;IAC1B,aAAa;IACb,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,sDAAsD;IACtD,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kCAAkC;IAClC,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,+CAA+C;IAC/C,sBAAsB;IACtB,oCAAoC;IACpC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,+CAA+C;IAC/C,WAAW;AACf;;AAEA,kCAAkC;AAClC;IACI,YAAY;IACZ,mBAAmB;IACnB,2CAA2C;IAC3C,kCAAkC;AACtC;;AAEA;IACI,0DAA0D;IAC1D,sDAAsD;IACtD,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,0CAA0C;IAC1C,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,kBAAkB;IAClB,wCAAwC;IACxC,kBAAkB;IAClB,+CAA+C;AACnD;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,+CAA+C;IAC/C,mDAAmD;IACnD,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA;IACI,+CAA+C;IAC/C,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB","sourcesContent":[".form-container {\n    background-color: #ffffff;\n    border-radius: 8px 8px 0 0;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n    border: 1px solid var(--therapist-border-color);\n    padding: 1.5rem;\n    height: calc(100vh - 320px);\n    overflow-y: auto;\n}\n\n.form-wrapper {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    position: relative; /* Added for overlay positioning */\n}\n\n.navigation-buttons {\n    background: #fff;\n    padding: 1rem 1.5rem;\n    border: 1px solid var(--therapist-border-color);\n    border-top: none;\n    border-radius: 0 0 8px 8px;\n    display: flex;\n    gap: 1rem;\n    justify-content: flex-end;\n}\n\n.form-title {\n    border-bottom: 2px solid var(--therapist-border-color);\n    margin-bottom: 1.5rem;\n    padding-bottom: 1rem;\n}\n\n.form-title p {\n    font-size: 20px;\n    font-weight: 500;\n    color: var(--therapist-text-color);\n    margin: 0;\n}\n\n.navigation-buttons button {\n    padding: 0.5rem 1.5rem;\n    border: 1px solid var(--therapist-accent-color);\n    background-color: #fff;\n    color: var(--therapist-accent-color);\n    border-radius: 6px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.navigation-buttons button:hover:not(:disabled) {\n    background-color: var(--therapist-accent-color);\n    color: #fff;\n}\n\n/* New styles for loading states */\n.navigation-buttons button:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n    border-color: var(--therapist-border-color);\n    color: var(--therapist-text-color);\n}\n\n.button-loading {\n    background-color: var(--therapist-border-color) !important;\n    border-color: var(--therapist-border-color) !important;\n    color: var(--therapist-text-color) !important;\n}\n\n.save-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(255, 255, 255, 0.8);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n    border-radius: 8px;\n}\n\n.save-overlay-content {\n    background-color: white;\n    padding: 1.5rem 2rem;\n    border-radius: 6px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    text-align: center;\n    border: 1px solid var(--therapist-border-color);\n}\n\n.save-overlay-content p {\n    color: var(--therapist-text-color);\n    margin: 0.5rem 0 0;\n    font-size: 14px;\n    font-weight: 500;\n}\n\n.spinner {\n    border: 3px solid var(--therapist-border-color);\n    border-top: 3px solid var(--therapist-accent-color);\n    border-radius: 50%;\n    width: 24px;\n    height: 24px;\n    animation: spin 1s linear infinite;\n    margin: 0 auto;\n}\n\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n.summary-section {\n    border: 1px solid var(--therapist-border-color);\n    border-radius: 10px;\n    background-color: #f0f8ff;\n    margin: 40px 0;\n    padding: 20px;\n}\n\n.summary-section p {\n    color: var(--therapist-text-color);\n}\n\n.summary-section span {\n    font-weight: 500;\n}\n\n.summary-section p:last-child {\n    margin: 0;\n}\n\n.summary-section-title {\n    color: var(--therapist-text-color);\n    font-size: 18px;\n    font-weight: 600;\n    margin-bottom: 20px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
